<template>
    <!-- 模拟组合 -->
    <div>
        <!-- 模拟组合列表 -->
        <div>
            <el-row class="row-four clearfix">
                <span class="fl">模拟组合详情</span>
                 <el-button type="built" class="fr" @click="build"><i class="el-icon-plus"></i> 新建模拟组合</el-button>
            </el-row>
            <el-table class="table-two mt20" :data="portfolioList" border>
                <el-table-column property="portfolioName" label="组合名称" align="left" width="200">
                    <template slot-scope="scope">
                        <div class="details">
                            <img v-if="scope.row.publicStatus" class="sign" src="@/assets/images/open.png" alt="">
                            <a class="line_one mainColor" :title="scope.row.portfolioName" :href="'#/combination?code='+scope.row.portfolioCode" target="_blank">{{scope.row.portfolioName}}</a>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="createDate" label="成立日期" width="110"></el-table-column>
                <el-table-column property="dealDate" label="净值日期" width="110"></el-table-column>
                <el-table-column property="unitEquity" label="单位净值"></el-table-column>
                <el-table-column property="annualYield" label="年化收益率">
                    <template slot-scope="scope">
                        <span :class="[{'rColor':parseFloat(scope.row.annualYield)>0},{'gColor':parseFloat(scope.row.annualYield)<0}]">{{scope.row.annualYield}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="volatilityIndex" label="年化波动率"></el-table-column>
                <el-table-column property="maxRetraceIndex" label="最大回撤"></el-table-column>
                <el-table-column property="sharpIndex" label="夏普比率"></el-table-column>
                <el-table-column property="opera" label="操作" width="180">
                    <template slot-scope="scope">
                        <span class="btn-normal" @click="operate('update',scope.row)">更新</span>
                        <span class="btn-normal" @click="operate('adjust',scope.row)">调仓</span>
                        <span class="btn-normal" @click="operate('delete',scope.row)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="pagination-one mt20"
                    hide-on-single-page
                    background
                    :page-size="portfolioPageNum"
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :total="portfolioTotal">
            </el-pagination>
        </div>
        <!-- 新建组合弹框 -->
        <el-dialog title="组合信息" class="dialog-normal" :visible.sync="dialogTableVisible" @close="close">
            <!-- 新建 -->
            <el-form class="form-info mt30" :model="addForm" :inline="true" label-position="right">
                <el-form-item label="名称">
                    <el-input v-if="addForm.isEdit" v-model="addForm.editName" style="width:150px;"></el-input>
                    <span v-else class="form-info-text" :title="addForm.name">{{addForm.name}}</span>
                </el-form-item>
                <el-form-item label="起始日期">
                    <el-date-picker v-if="addForm.isEdit" type="date" class="date-picker-one" style="width: 115px;" v-model="addForm.editDate" :editable="false" placeholder="选择日期" :clearable="false" value-format="yyyy-MM-dd"></el-date-picker>
                    <span v-else class="form-info-text">{{addForm.date}}</span>
                </el-form-item>
                <el-form-item label="流动资产年化收益率" title="调整区间在-10%~100%">
                    <el-input v-if="addForm.isEdit" v-model="addForm.editYield" style="width:90px;" @input="yieldInput"><i slot="suffix" class="el-input__icon">%</i></el-input>
                    <span v-else class="form-info-text">{{addForm.yield}}%</span>
                </el-form-item>
                <el-form-item label="公开">
                    <el-checkbox v-if="addForm.isEdit" v-model="addForm.editChecked"></el-checkbox>
                    <el-checkbox v-else v-model="addForm.checked" disabled></el-checkbox>
                    <span></span>
                </el-form-item>
                <el-form-item>
                    <template v-if="addForm.isEdit">
                        <el-button type="normal" @click="operateInfo('preserve')">保存</el-button>
                        <el-button type="cancel" @click="operateInfo('cancel')">取消</el-button>
                    </template>
                    <template v-else><el-button type="normal" @click="operateInfo('modify')">修改</el-button></template>
                </el-form-item>
            </el-form>
            <!-- 调仓 -->
            <div v-show="informationShow" class="adjustBox">
                <div class="mt30 mb30 search">
                    <el-input placeholder="请输入内容" class="search-input" prefix-icon="el-icon-search" v-model="search"></el-input>
                    <el-button type="normal" class="ml20" @click="getFundLists">搜索</el-button>
                </div>
                <div class="adjustBox-border">
                    <el-table class="table-two" :data="gridData" height="240">
                        <el-table-column type="index" width="50"></el-table-column>
                        <el-table-column property="secuNameAbbr" label="产品名称" width="230">
                            <template slot-scope="scope">
                              <a class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/product?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column property="managerName" label="基金管理人"></el-table-column>
                        <el-table-column property="createDate" label="成立日期"></el-table-column>
                        <el-table-column property="newestDate" label="最新净值日期"></el-table-column>
                        <el-table-column property="newestEquity" label="最新净值">
                            <template slot-scope="scope"><span>{{parseFloat(scope.row.newestEquity).toFixed(4)}}</span></template>
                        </el-table-column>
                        <el-table-column property="thisYearYield" label="今年以来收益">
                            <template slot-scope="scope">
                                <span :class="[{rColor:scope.row.thisYearYield>0},{gColor:scope.row.thisYearYield<0}]">{{parseFloat(scope.row.thisYearYield*100).toFixed(2)}}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column property="opera" label="操作" width="150">
                            <template slot-scope="scope">
                                <span class="mainColor" @click="addTrade(scope.row)">添加到交易标的</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="adjustBox-Subject">
                        <div class="form-info-line">
                            <span>交易标的</span>
                            <!-- <el-radio-group class="radio-btns ml20" v-model="varianceRadio" @change="varianceChange">
                                <el-radio-button label="自定义"></el-radio-button>
                                <el-radio-button label="均值方差"></el-radio-button>
                            </el-radio-group> -->
                        </div>
                        <div class="adjustBox-Subject-con">
                            <!-- 自定义 -->
                            <div v-if="varianceRadio=='自定义'" class="side1">
                                <el-form :model="tradeForm" class="form-one" :inline="true" label-position="right">
                                    <el-form-item label="交易日期">
                                        <el-date-picker type="date" class="date-picker-one" v-model="tradeForm.tradeDate" @change="tradeDateChange" style="width:115px;" :editable="false" placeholder="选择日期" :clearable="false" value-format="yyyy-MM-dd"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="权重类型">
                                        <el-select v-model="tradeForm.tradeType" class="select-one" style="width:102px;">
                                            <el-option label="当期权重" value="当期权重"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="证券权重">
                                        <el-input v-model="tradeForm.security" class="dashed-line" :disabled="true"><i slot="suffix" class="el-input__icon" style="width: 30px;display: inline-block;">%</i></el-input>
                                    </el-form-item>
                                    <el-form-item label="流动资产权重">
                                        <el-input v-model="tradeForm.assets" class="dashed-line" :disabled="true"><i slot="suffix" class="el-input__icon" style="width: 30px;display: inline-block;">%</i></el-input>
                                    </el-form-item>
                                </el-form>
                                <el-table class="table-two" :data="adjustData" border  height="250">
                                    <el-table-column type="index" width="50"></el-table-column>
                                    <el-table-column property="secuNameAbbr" label="产品名称" width="230">
                                        <template slot-scope="scope">
                                            <a class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/product?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column property="newestEquity" label="当前净值">
                                        <template slot-scope="scope">{{parseFloat(scope.row.newestEquity).toFixed(4)}}</template>
                                    </el-table-column>
                                    <el-table-column property="date" label="当期权重">
                                        <template slot-scope="scope">
                                            <span v-if="adjustData[scope.$index].isEdit" class="mainColor" @click="adjustData[scope.$index].isEdit = false">可编辑</span>
                                            <el-input v-else v-model="adjustData[scope.$index].dqCon" class="input-normal" style="width:95px;" @input="dqConChange($event,scope.$index)" @blur="dqConBlur($event,scope.$index)"><i slot="suffix" class="el-input__icon">%</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column property="opera" label="操作" width="120">
                                        <template slot-scope="scope">
                                            <span class="mainColor" @click="deleteTrade(scope.row)">删除</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <!-- 均值方差 -->
                            <!-- <div v-else class="side2">
                                <chart id="jzfc" style="width: 550px;height: 350px;" :option="optionJzfc" @event="getEvent"></chart>
                                <div style="margin-left: 10px;">
                                    <el-form :model="tradeForm" class="form-one" :inline="true" label-position="right" style="text-align: left;">
                                        <el-form-item label="交易日期">
                                            <el-date-picker type="date" class="date-picker-one" v-model="tradeForm.tradeDate" style="width:100px;" :editable="false" placeholder="选择日期" :clearable="false" value-format="yyyy-MM-dd" @change="getMeanVariance"></el-date-picker>
                                        </el-form-item>
                                    </el-form>
                                    <el-table class="table-two" :data="varianceData" border  height="244">
                                        <el-table-column type="index" width="50"></el-table-column>
                                        <el-table-column property="secuNameAbbr" label="产品名称" width="230">
                                            <template slot-scope="scope">
                                                <a class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/product?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                                            </template>
                                        </el-table-column>
                                        <el-table-column property="date" label="当期权重">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.dqCon}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div> -->
                            <el-button type="normal" style="margin:26px auto;" @click="tradeConfirm">确认交易</el-button>
                        </div>
                    </div>
                </div>
                <!-- 组合持仓详情 -->
                <div class="hold">
                    <div class="hold-box">
                        <div class="form-info-line">
                            <span>组合持仓详情</span>
                            <el-select v-model="positionDate" class="select-one fr" style="width:118px;" @change="positionDateChange">
                                <el-option v-for="(item,i) in holdDate" :key="i+'d'" :label="item" :value="item"></el-option>
                            </el-select>
                        </div>
                        <el-table class="table-two" :data="holdData" ref="holdDataRef" height="292" border>
                            <el-table-column type="index" width="50"></el-table-column>
                            <el-table-column property="secuNameAbbr" label="产品名称" width="120">
                                <template slot-scope="scope">
                                    <a class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/product?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                                </template>
                            </el-table-column>
                            <el-table-column property="dealDate" label="交易日期" width="100"></el-table-column>
                            <el-table-column property="proportion" label="期初权重"></el-table-column>
                            <el-table-column property="endProportion" label="期末权重"></el-table-column>
                            <el-table-column property="totalYield" label="区间收益率" width="100">
                                <template slot-scope="scope">
                                    <span :class="[{'rColor':parseFloat(scope.row.totalYield)>0},{'gColor':parseFloat(scope.row.totalYield)<0}]">{{scope.row.totalYield}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <table class="hold-table" cellspacing="0"> 
                            <tbody>
                                <tr>
                                    <td style="width:50px"></td>
                                    <td style="width:120px">{{holdActive.secuNameAbbr}}</td>
                                    <td style="width:100px"></td>
                                    <td style="width:81px">{{holdActive.proportion}}</td>
                                    <td></td>
                                    <td style="width:100px"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="hold-box">
                        <div class="form-info-line">组合证券权重走势</div>
                        <div style="border:1px solid #E5E5E5;height: 337px;">
                            <chart :option="optionZhrx" id="zhrx" style="width:531px;height:330px;"></chart>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import chart from "../../components/chart";
    export default {
        name: "analogCombinationDetails",
        components:{
            chart
        },
        data() {
            return {
                // 模拟组合列表
                portfolioList:[],
                portfolioPage:1,
                portfolioPageNum:10,
                portfolioTotal:0,
                // 弹框
                dialogTableVisible:false,
                informationShow:false,
                addForm:{
                    editName:'',
                    name:'',
                    editDate:'',
                    date:'',
                    editYield:'',
                    yield:'',
                    isEdit:true,
                    editChecked: false,
                    checked: false,
                },
                activePortfolioCode:'',//选中组合
                // 基金搜索
                search:'',
                gridData: [],
                // 交易标的
                tradeForm:{
                    tradeDate:'',
                    tradeType:'当期权重',
                    security:'0.00',
                    assets:'',
                },
                adjustData:[],
                // 持仓列表
                holdData:[],
                holdDate:[],//时间
                holdActive:{},
                positionDate:'',
                optionZhrx:{
                    title:{},
                    legend:{
                        type:'scroll',itemHeight:20,bottom:10,itemGap:20,formatter:'{name}',textStyle:{fontSize:14,color:'#333',},pageIconColor: "#01567F",
                    },
                    grid: {top:'10%',left: '2%',right: '7%',bottom: '15%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter:function (params) {
                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>=0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'%</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[]
                },
                // 均值方差
                varianceRadio: '自定义',
                optionJzfc: {
                    title: {text: '收益率',left:5,textStyle:{color:'#5D5D5D',fontWeight:'normal',fontSize:12,} },
                    visualMap: {
                        min: 0,
                        max: 0.2,
                        precision: 2,//数据展示的小数精度，默认为0，无小数点。
                        realtime: false,
                        itemWidth: 15,
                        itemHeight: 180,
                        align: 'left',
                        orient: 'vertical',
                        right: 0,
                        top: 'center',
                        calculable: true,
                        inRange: {
                            color: ['#f2c31a', '#24b7f2']
                        }
                    },
                    grid: {top:'15%',left: '0%',right: '15%',bottom: '10%',containLabel: true},
                    tooltip: {
                        axisPointer: {
                            type: 'cross'
                        },
                        trigger: 'axis',
                        formatter: function (params) {
                            // console.log(params);
                            var htmlStr = '<div class="echarts-tooltip-one"><table>';
                            for (let i = 0; i < params.length; i++) {
                                htmlStr += '<tr><td><span class="color-block"' + '"></span>' + params[i].seriesName + '：</td><td>（' + (params[i].data[0] * 100).toFixed(2) + '%，'+(params[i].data[1] * 100).toFixed(2)+'%）</td></tr>';
                            }
                            htmlStr += '</table></div>';
                            return htmlStr;
                        }
                    },
                    xAxis: {
                        type: 'value',
                        name: '波动率',
                        min: function(value) {
                            return Number(value.min) - 0.02
                        },
                        nameTextStyle: {color:'#5D5D5D',fontSize:12,},
                        axisLine:{lineStyle:{color: "#DCDCDC"}},
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:12,color:'#70787F'
                        },
                        data: [],
                    },
                    yAxis: {
                        type: 'value',
                        axisLine:{lineStyle:{color: "#DCDCDC"}},
                        min: function(value) {
                            return Number(value.min) - 0.01
                        },
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:12,color:'#70787F'
                        },
                    },
                    series: [
                        {
                            name: '方差',
                            type: 'scatter',
                            symbolSize: 5,
                            data:[],
                        },
                        {
                            name: '有效前沿',
                            type: 'line',
                            showAllSymbol: true,//示折线图上所有小标签
                            showSymbol: false,
                            color: '#B81616',
                            lineStyle: { color: "#B81616" },
                            data:[],
                        },
                    ],
                },
                varianceData:[],
            }
        },
        mounted() {
            this.getPortfolioList()
        },
        updated () {
            if(this.informationShow) {
                this.$nextTick(() => {
                    this.$refs['holdDataRef'].doLayout();
                })
            }
        },
        watch:{
            tradeForm: {
                handler (val) {
                    this.tradeForm.assets = (100 - this.tradeForm.security).toFixed(2)
                },
                deep: true
            },
        },
        methods:{
            close() {
                this.search = ''
                this.gridData = []
                this.tradeForm.security = 0
                this.varianceRadio = '自定义'
            },
            build() {
                this.addForm =  {
                    editName: '',
                    name: '',
                    editDate: '',
                    date: '',
                    editYield: '',
                    yield: '',
                    isEdit: true,
                    editChecked: false,
                    checked: false,
                }
                this.activePortfolioCode = ''
                this.dialogTableVisible = true
                this.informationShow = false
            },
            // 模拟组合列表
            getPortfolioList() {
                this.$http.post(this.$apiPath.GetPortfolioList,{
                    Page:this.portfolioPage,
                    PageNum:this.portfolioPageNum
                }).then(res => {
                    if(res.data.code == 200) {
                        this.portfolioList = res.data.data.dataList
                        this.portfolioTotal = res.data.data.recordCount
                    }
                }).catch(err=>{})
            },
            handleCurrentChange(newPage) {
                this.portfolioPage = newPage
                this.getPortfolioList()
            },
            // 更新组合
            async comUpdate(code) {
                let vm = this
                await vm.$http.post(vm.$apiPath.CalculatioPortfolio,{
                    PortfolioCode:code,
                }).then(res => {
                    // console.log(res);
                    if( res.data.code == 200 && res.data.data.note) {
                        vm.$message.success('更新成功')
                        vm.getPortfolioList()
                    } else {
                        vm.$message.error('更新失败，请稍后再试')
                    }
                }).catch(err=>{})
            },
            // 单只组合操作
            operate(type,row) {
                // console.log(row);
                let vm = this
                vm.activePortfolioCode = row.portfolioCode
                if(type == 'update') {//更新
                    vm.comUpdate(row.portfolioCode)
                } else if(type == 'adjust') {//调仓
                    vm.dialogTableVisible = true
                    vm.getPositionDate()
                    vm.informationShow = true
                    // 组合基本信息
                    vm.$http.post(vm.$apiPath.GetPortfolioInfo,{
                        PortfolioCode:row.portfolioCode,
                    }).then(res => {
                        // console.log(res);
                        if(res.data.code == 200) {
                            let xdata = res.data.data
                            vm.addForm =  {
                                editName: xdata.portfolioName,
                                name: xdata.portfolioName,
                                editDate: xdata.createDate,
                                date: xdata.createDate,
                                editYield: xdata.cashYield*100,
                                yield: xdata.cashYield*100,
                                isEdit: false,
                                editChecked: xdata.publicStatus,
                                checked: xdata.publicStatus
                            }
                        } 
                    }).catch(err=>{})
                } else if(type == 'delete') {//删除
                    this.$confirm('确定要删除 ' + row.portfolioName +' 吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        vm.$http.post(vm.$apiPath.DeletePortfolio,{
                            PortfolioCode:row.portfolioCode,
                        }).then(res => {
                            // console.log(res);
                            if(res.data.code == 200) {
                                vm.$message.success('删除成功')
                                vm.getPortfolioList()
                            } 
                        }).catch(err=>{})
                    }).catch(() => {});
                }
            },
            // 收益率验证
            yieldInput(val) {
                this.addForm.editYield = this.addForm.editYield.replace(/[^0-9.-]/g, "");
                if (val < -10) { // 如果输入的值小于0
                    this.addForm.editYield = 0;
                } else if (val > 100) { // 如果输入的值大于等于100
                    this.addForm.editYield = 100;
                }
            },
            // 弹框组合信息操作
            operateInfo(type) {
                let vm = this
                if(type == 'preserve') {//保存
                    if(vm.addForm.editName===''||vm.addForm.editDate===''||(vm.addForm.editYield==='')) {
                        vm.$message.error('请先完善信息')
                    } else {
                        if(vm.activePortfolioCode == '') {//新建
                            vm.$http.post(vm.$apiPath.CreatePortfolio,{
                                PortfolioName: vm.addForm.editName,     //组合名称
                                CreateDate:  vm.addForm.editDate,       //创建日期
                                CashYield:  vm.addForm.editYield,       //流动资产年化收益
                                PublicStatus: vm.addForm.editChecked    //公开状态
                            }).then(res => {
                                // console.log('创建',res);
                                if(res.data.code == 200) {
                                    vm.activePortfolioCode = res.data.data.note
                                    vm.$message.success('创建组合成功')
                                    vm.addForm.name = vm.addForm.editName
                                    vm.addForm.date = vm.addForm.editDate
                                    vm.addForm.yield = vm.addForm.editYield
                                    vm.addForm.checked = vm.addForm.editChecked
                                    vm.addForm.isEdit = false 
                                    vm.informationShow = true
                                    vm.getPortfolioList()
                                    this.getPositionDate()// 获取组合调仓日期
                                } 
                            }).catch(err=>{})
                        } else {//调仓
                            vm.$http.post(vm.$apiPath.SetPortfolioInfo,{
                                PortfolioCode: vm.activePortfolioCode-0,    //组合编号
                                PortfolioName: vm.addForm.editName,         //组合名称
                                CreateDate: vm.addForm.editDate,            //创建日期
                                CashYield: String(vm.addForm.editYield),    //流动资产年化收益
                                PublicStatus: vm.addForm.editChecked        //公开状态
                            }).then(res => {
                                // console.log('修改',res);
                                if(res.data.code == 200) {
                                    vm.$message.success('修改组合成功')
                                    vm.addForm.name = vm.addForm.editName
                                    vm.addForm.date = vm.addForm.editDate
                                    vm.addForm.yield = vm.addForm.editYield
                                    vm.addForm.checked = vm.addForm.editChecked
                                    vm.addForm.isEdit=false
                                    vm.getPortfolioList()
                                } 
                            }).catch(err=>{})
                        }
                    }
                } else if(type == 'cancel') {
                    if(vm.activePortfolioCode == '') {
                        vm.dialogTableVisible = false
                    } else {
                        vm.addForm.editName = vm.addForm.name
                        vm.addForm.editDate = vm.addForm.date
                        vm.addForm.editYield = vm.addForm.yield
                        vm.addForm.editChecked = vm.addForm.checked
                        vm.addForm.isEdit=false
                    }
                } else if(type == 'modify') {
                    vm.addForm.isEdit=true
                }
            },
            // 基金搜索
            getFundLists() {
                let vm = this
                vm.gridData = []
                vm.$http.post(vm.$apiPath.GetFundSeachResult, {
                    KeyWords: vm.search.trim(), //模糊查询关键词
                    Page: 1, //页码
                    PageNum: 10 //每页条数
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == "200") {
                        vm.gridData = res.data.data.dataList
                    }
                }).catch(err => { })
            },
            // 交易标的时间改变
            tradeDateChange(val) {
                this.adjustData = []
                this.$http.post(this.$apiPath.GetPortfolioFundByDate, {
                    PortfolioCode: this.activePortfolioCode-0,
                    DealDate: val
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == "200") {
                        let list = res.data.data.dataList
                        if(list.length > 0 ) {
                            let total = 0
                            for(let i = 0; i < list.length; i++) {
                                if(list[i].innerCode != 0) {
                                    this.adjustData.push({
                                        innerCode:list[i].innerCode,
                                        secuNameAbbr:list[i].secuNameAbbr,
                                        newestEquity:list[i].unitEquity,                     //单位净值
                                        isEdit:false,
                                        dqCon:parseFloat(list[i].proportion*100).toFixed(2)  //当期权重
                                    })
                                    total += parseFloat(list[i].proportion*100)
                                } 
                            }
                            // console.log('自定义表格',this.adjustData);
                            this.tradeForm.security = parseFloat(total).toFixed(2)                          //证券权重
                        }
                    }
                }).catch(err => { })
            },
            addTrade(val) {
                for(let i = 0; i < this.adjustData.length; i++) {
                    if(this.adjustData[i].innerCode == val.innerCode) {
                        return;
                    }
                }
                this.adjustData.push({
                    innerCode:val.innerCode,
                    secuNameAbbr:val.secuNameAbbr,
                    newestEquity:val.newestEquity,
                    isEdit:true,
                    dqCon:0
                })
                this.$message.success('添加成功')
            },
            dqConChange(val,index) {
                let vm = this, all = 0;
                vm.adjustData.forEach(item =>{
                    all += parseFloat(item.dqCon)
                })
                all = isNaN(all)? 0 : all
                if(parseFloat(all) >= 0 && parseFloat(all) <= 100) {
                    vm.tradeForm.security = (all).toFixed(2)
                } else {
                    vm.$message.error('当期权重累加范围为0~100')
                    all = 0
                    for(let i = 0; i < vm.adjustData.length; i++) {
                        if(i == index) break;
                        all += parseFloat(vm.adjustData[i].dqCon)
                    }
                    this.adjustData[index].dqCon = 100 - all
                    vm.tradeForm.security = all < 0? 0 : 100
                }
            },
            dqConBlur(val,index) {
                let value = this.adjustData[index].dqCon
                this.adjustData[index].dqCon = (isNaN(value) || value == '')? 0 : parseFloat(value).toFixed(2)
            },
            // 确认交易
            tradeConfirm() {
                let vm = this,list = new Array(),proportion=0,flow = 0;
                if(vm.varianceRadio == '自定义') {
                    vm.adjustData.forEach(item => {
                        list.push({
                            InnerCode:item.innerCode,
                            Proportion:item.dqCon/100,
                        })
                    })
                    flow = vm.tradeForm.assets
                } else {// 均值方差
                    vm.varianceData.forEach(item => {
                        proportion += Number(item.dqCon)
                        list.push({
                            InnerCode:item.innerCode,
                            Proportion:item.dqCon/100,
                        })
                    })
                    flow = 100-proportion
                }
                
                // console.log('流动资产',flow,'列表',list);
                if(vm.tradeForm.tradeDate == '') {
                    vm.$message.error('请先选择交易日期')
                } else {
                    vm.$http.post(vm.$apiPath.SetPortfolioFundByDate, {
                        PortfolioCode:vm.activePortfolioCode,//组合编号
                        DealDate: vm.tradeForm.tradeDate, //调仓日期
                        CashProportion: flow==0?0:flow/100, //流动资产持仓
                        FundList: list //基金列表
                    }).then(async res => {
                        // console.log(res);
                        if (res.data.code == "200" && res.data.data.note) {
                            await vm.comUpdate(vm.activePortfolioCode)//更新组合
                            await vm.getPositionDate()
                            vm.$message.success('设置组合 '+ vm.tradeForm.tradeDate + ' 持仓成功')
                       } else {
                            vm.$message.error('设置组合 '+ vm.tradeForm.tradeDate + ' 持仓失败')
                        }
                    }).catch(err => { })
                }
            },
            // 删除交易标的
            deleteTrade(val) {
                const i1 = this.adjustData.findIndex(item => item.innerCode == val.innerCode)
                this.adjustData.splice(i1, 1)
                this.tradeForm.security = this.tradeForm.security - val.dqCon
            },
            // 组合持仓详情
            getPortfolioPosition() {
                let vm = this
                vm.holdData = []
                this.optionZhrx.series = []
                this.optionZhrx.xAxis.data = []
                vm.$http.post(vm.$apiPath.GetPortfolioPosition, {
                    PortfolioCode:vm.activePortfolioCode,// 
                    DealDate:vm.positionDate,
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == "200") {
                        vm.holdData = res.data.data.fundList.filter(item => item.innerCode != 0)
                        vm.holdActive = res.data.data.fundList[0]
                        vm.optionZhrx.xAxis.data = res.data.data.chartsList.dateList
                        res.data.data.chartsList.nameList.forEach((item,i) => {
                            vm.optionZhrx.series.push({
                                name: item,
                                type: 'line',
                                symbol:'circle',showSymbol: false,symbolSize:8,areaStyle:{},stack: 'Total',
                                data: res.data.data.chartsList.dataList[i]
                            })
                        });
                    }
                }).catch(err => { })
            },
            // 获取组合调仓日期
            async getPositionDate() {
                let vm = this
                await vm.$http.post(vm.$apiPath.GetPositionDate, {
                    PortfolioCode:vm.activePortfolioCode,// 
                }).then(res => {
                    if (res.data.code == "200") {
                        vm.holdDate = res.data.data.dataList
                        vm.positionDate = vm.holdDate[vm.holdDate.length-1]
                        vm.tradeForm.tradeDate = vm.holdDate[vm.holdDate.length-1]
                        vm.getPortfolioPosition()//组合持仓详情
                        vm.tradeDateChange(vm.tradeForm.tradeDate)
                    }
                }).catch(err => { })
            },
            // 持仓时间改变
            positionDateChange(val) {
                this.positionDate = val
                this.getPortfolioPosition()
            },
            // 均值方差
            getMeanVariance() {
                let vm = this
                let arr = []
                vm.varianceData = []
                vm.adjustData.forEach(item => {
                    arr.push(Number(item.innerCode))
                })
                vm.$http.post(vm.$apiPath.GetMeanVariance, {
                    InnerCodes:arr,//[2190285,2272280,2114798,2067596,2264452]
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        let xdata = res.data.data
                        xdata.nameList.forEach((item,i) => {
                            vm.varianceData.push({
                                secuNameAbbr: item,
                                innerCode: xdata.fundList[i].name,
                                dqCon: parseFloat(xdata.fundList[i].value[0]*100).toFixed(2),
                                values: xdata.fundList[i].value
                            })
                        })
                        // console.log('均值方差',vm.varianceData);
                        vm.optionJzfc.series[0].data = xdata.dotList
                        vm.optionJzfc.series[1].data = xdata.lineList 
                        vm.optionJzfc.visualMap.max = xdata.scopeList[0]
                        vm.optionJzfc.visualMap.min = xdata.scopeList[1]
                    }
                }).catch(err => { })
            },
            getEvent(val) {
                let vm = this
                // console.log(val);
                vm.varianceData.forEach((item,i) => {
                    item.dqCon = parseFloat(item.values[val.dataIndex]*100).toFixed(2)
                })
            },
            varianceChange(val) {
                if(val == '均值方差') {
                    this.getMeanVariance()
                }
            }
        },
    }
</script>

<style scoped lang="less">
.el-radio-group.radio-btns .el-radio-button /deep/.el-radio-button__inner {border:1px solid @colorE5!important;}
.input-normal{/deep/.el-input__inner{text-align: right;line-height: 25px;}}
.details {
    position: relative;
    .sign {position: absolute;left: 0;top: 50%;transform: translateY(-50%);width: 28px;height: 16px;}
    a {box-sizing: border-box;display: block;width: 100%;padding-left: 30px;}
}
.adjustBox {
    border-top: 1px solid @colorE5;
    .search {
        display: flex;justify-content: center;align-items: center;
        &-input {
            width: 410px;
            /deep/.el-input__inner{height: 30px; border-color: @borderColor;line-height: 30px;}
            /deep/.el-input__icon{line-height: 30px;}
        }
    }
    &-border {border: 1px solid @colorE5!important;}
    &-Subject {
        padding: 0 15px;
        &-con {
            text-align: center;
            .side1 {margin: 0 115px;}
            .side2 {display: flex;justify-content: center;}
        }
    }
    .form-one {
        /deep/.el-date-editor{max-width: 102px!important;}
        /deep/.el-form-item{
            margin-right: 30px;
            .el-form-item__label{padding-right: 12px;}
        }
        /deep/.el-form-item:last-child{margin-right: 0;}
    }
}
</style>